import { Component, inject, OnInit } from "@angular/core";
import { NxCell } from "qlik";
import { Title } from "@angular/platform-browser";
import { FilterComponent } from "../../felles/components/filter/filter.component";
import { QlikService } from "../../felles/services/qlik.service";
import { AccordionComponent } from "@husbanken/designsystem-angular-core";
import { AccordionElementComponent } from "@husbanken/designsystem-angular-core";
import { TableComponent } from "src/app/felles/components/table/table.component";

@Component({
  selector: "stat-kommune-hovedtall",
  templateUrl: "./kommuneside.component.html",
  imports: [FilterComponent, AccordionComponent, AccordionElementComponent, TableComponent],
})
export class KommunesideComponent implements OnInit {
  valgtFilter: { [key: string]: NxCell[] } = null;
  objectKeys = Object.keys;

  qlikService = inject(QlikService);
  titleService = inject(Title);

  constructor() {
    this.qlikService.resetFilter();
    this.qlikService.setFylkeFilter();
    this.qlikService.setFilter("VirkemiddelKode", "BOSTØTTE", false, true);
    this.qlikService.setFilter("TypeTilstand", "Utbetaling", false, true);
  }

  ngOnInit() {
    this.titleService.setTitle("Statistikk - Nøkkeltall - Husbanken");
  }

  filterVisning(event) {
    this.valgtFilter = event;
  }
}
